import { useMemo } from 'react';
import webBiLogger from '@wix/web-bi-logger';

export function useBiLogger() {
  const biLogger = useMemo(() => webBiLogger.factory().logger(), []);

  return biLogger;
}
